// Module
var code = "<input type=\"text\" class=\"initFormInput\" data-type=\"{{type}}\" placeholder=\"{{placeholder}}\" value=\"{{value}}\">";
// Exports
export default code;